<template>  
    <section>
		<div @click='navigateTo("./personal-data")' class="user-info">
			<div class="logo-work">
				<img :src="userIcon" alt="" class="user-icon" v-if="userInfo.user_icon">
				<div class="logo" v-else></div>
			</div>
			<p class="text">{{userInfo.user_name||userName}}</p>
		</div>
        <div class="my-wallet" @click="navigateTo('./wallet')">
			<span class="wallet-logo wallet"></span>
			<div class="wallet-name">我的钱包</div>
		</div>
		
		<div class="my-wallet"  @click="navigateTo('./news')">
			<span class="news-logo wallet"></span>
			<div class="wallet-name">我的消息</div>
		</div>



		<div class="my-wallet">
			<span class="notice-logo wallet"></span>
			<div class="notice-wrap">
				<span class="notice-on">公众号服务通知</span>
				<span class="notice" @click="switchNotice" :class='noticeFlag?"on":"off"'></span>
			</div>
		</div>

<!--      <div class="my-wallet"  @click="loginOut">
        <span class="news-logo wallet"></span>
        <div class="wallet-name">退出</div>
      </div>-->
    </section>
</template>

<script>

    import imageUpload from '@/components/ImageUpload'
    import utils from '@/assets/jslibs/utils'
    import {getUserInfo,WechatParLogin} from '@/api/common'
    import {WechatNotice} from '@/api/personal'
    export default {
        name: 'index',
		data(){
			return{
				imgUrl:this.$store.state.imgUrl || sessionStorage.getItem("imgUrl"),
				userName:"用心淘"+Math.floor(Math.random()*10000),
				noticeFlag:false,
				userInfo:{},
                isMobile:utils.isMobile(),
                icon_images:[]
			}
		},
        components: {
            imageUpload
        },
		
		beforeCreate(){
			sessionStorage.setItem("roleType","customer")
		},
       
        created() {
            this.getUserInfo()
        },

      computed: {
        userIcon(){
          return this.httpFilterFUN(this.userInfo.user_icon) ? this.userInfo.user_icon : this.imgUrl + this.userInfo.user_icon
        }
      },
        mounted(){
            document.title = "个人中心"
        },
        
        methods: {
			//获取用户信息
			async getUserInfo(){
			    const { data, status } = await getUserInfo();
			    if (status !== 200) return 
			    this.userInfo = data
				if(this.userInfo.is_wechat_notice == "1"){//不接受微信通知
					this.noticeFlag = false
				}else{
					this.noticeFlag = true
				}
			},
			
            navigateTo(path){
                this.$router.push(path)
            },
            
            async getWechatCode(){
                const code = utils.getQueryString('code') // 截取路径中的code，如果没有就去微信授权，如果已经获取到了就直接传code给后台获取openId
                const appId = "wxf3c9d00e530fedd8";
                const url = window.location.href;
                if (code == null || code === '') {
                    window.location.href = 'https://open.weixin.qq.com/connect/oauth2/authorize?appid=' + appId + '&redirect_uri=' + encodeURIComponent(url) + '&response_type=code&scope=snsapi_base&state=1#wechat_redirect'
                } else {
                    this.wechatParLogin(code) //把code传给后台获取用户信息
                }
            },
            
            async wechatParLogin(code){
                let obj = {code:code}
                const { status,data } = await WechatParLogin(obj);
                if (status !== 200) return
            }, 
            
            
            // 开启,关闭微信通知
            async WechatNotice(){
                const { status,data } = await WechatNotice();
                if (status !== 200) return
                this.noticeFlag =!this.noticeFlag
            },

          async loginOut(){
            utils.setCookie('X-Access-Token', "", -1);
            utils.removeSession('X-Access-Token');
            utils.removeSession('imgUrl');
            //this.$router.push('./login');
          },
            
			switchNotice(){
                if(this.isMobile==3){//微信浏览器
                    if(this.userInfo.open_id){//已授权
                        this.WechatNotice()
                    
                    }else{
                        this.getWechatCode()
                    }
                }
                
                else{
                    window.toast("请到微信浏览器打开","txt");
                    return
                }
			},

          httpFilterFUN(valueStr) {
            if (valueStr != "" && valueStr != null) {
              if (valueStr.indexOf("www") >= 0 || valueStr.indexOf("http") >= 0 || valueStr.indexOf("https") >= 0) {
                return true;
              } else {
                return false;
              }
            } else {
              return false;
            }
          }
        },
    }
</script>

<style lang='less' scoped>
	@import '~@/assets/styles/variable.less';
	@import '~@/assets/styles/handleMethods.less';
	@import '~@/assets/styles/reset.css';
    section{font-family:PingFangSC-Regular;;font-weight:500;background: #fff;padding-bottom: 50px}
	.user-info{margin-bottom: 20px;}
    .logo-work{position: relative}
	.user-icon{display: block;width: 60px;height: 60px;margin: 0 auto;margin-top: 36px;border-radius: 50%}
	.logo{width: 60px;height: 60px;margin: 0 auto;margin-top: 36px;background: url(../assets/images/personal/pic_head_bg.png) no-repeat center center;background-size: cover}
    .work{position: absolute;right: 0;top: 0.4rem;;width:60px;height:28px;line-height: 28px;background:rgba(255,134,48,1);border-radius:100px 0px 0px 100px;text-align: center;font-size:15px;font-family:PingFangSC-Semibold;font-weight:600;color:rgba(255,255,255,1);}
	.text{color:rgba(51,51,51,1);font-size: 17px;margin-top: 16px;text-align:center}
	.my-wallet{display: -webkit-box;display: -ms-flexbox;display: flex;padding-left:16px;height: 52px;line-height: 52px;align-items: center;}
	.wallet{margin-right: 20px;display: inline-block;width: 20px;height: 20px;}
	.wallet-logo{background: url(../assets/images/personal/ic_mine_money.png) no-repeat center center;background-size: cover;}
	.news-logo{background: url(../assets/images/personal/ic_mine_message.png) no-repeat center center;background-size: cover;}
	.notice-logo{background: url(../assets/images/personal/ic_mine_wechat.png) no-repeat center center;background-size: cover;}
	.wallet-name{color:rgba(51,51,51,1);font-size: 17px;flex: 1;border-bottom: 1px solid #EEEEEE;background: url(../assets/images/home/ic_home_enter.png) no-repeat 297px center;background-size: 8px;}
	.notice-wrap{color:rgba(51,51,51,1);font-size: 17px;flex: 1;border-bottom: 1px solid #EEEEEE;}
	.notice-on{display: inline-block;width: 232px;margin-right: 20px}
	.notice{width: 50px;height:52px;display: inline-block;vertical-align: middle;}
	.on{background: url(../assets/images/personal/pic_mine_on.png) no-repeat center center;background-size: 50px;}
	.off{background: url(../assets/images/personal/pic_mine_off.png) no-repeat center center;background-size: 50px;}
</style>
